import React, { useState, useEffect } from 'react';
import {
    List,
    CheckCircle2,
    XCircle,
    Clock,
    Calendar,
    Eye,
    Inbox,
    Check,
    MapPin,
    User,
    Phone,
    MessageSquare,
    MapPinned,
    X,
    Euro,
    Route,
    ShieldCheck, Gift
} from "lucide-react";
import { cn } from '../utils/cn.js';
import toast from 'react-hot-toast';
import APIENDPOINT from './config.js';
export const DriverDashboard = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const [stats, setStats] = useState({ available: 0, total: 0, upcoming: 0, accepted: 0, rejected: 0, today: 0, completed: 0 });
    const [bookings, setBookings] = useState([]);
    const [filter, setFilter] = useState('available');
    // Modal States
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const [selectedHours, setSelectedHours] = useState(0);
    const [selectedMinutes, setSelectedMinutes] = useState(10);
    const [otpInput, setOtpInput] = useState("");
    const [closingOtpInput, setClosingOtpInput] = useState("");

    const [showStartModal, setShowStartModal] = useState(false);
    const [showConfirmStart, setShowConfirmStart] = useState(false);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [showCloseTripModal, setShowCloseTripModal] = useState(false);
    const [showClosingOtpModal, setShowClosingOtpModal] = useState(false);
    // Loyalty/Price States
    const [editablePrice, setEditablePrice] = useState(0);
    const [useLoyalty, setUseLoyalty] = useState(false);
    const [pointsToUse, setPointsToUse] = useState(0);
    const [pointsBalance, setPointsBalance] = useState(0);
    const fetchStats = async () => {
        const res = await fetch(`${APIENDPOINT}driverbooking.php?action=stats&driver_id=${user.id}`);
        const data = await res.json();
        setStats(data);
    };

    const fetchBookings = async () => {
        const res = await fetch(`${APIENDPOINT}driverbooking.php?action=list&driver_id=${user.id}&filter=${filter}`);
        const data = await res.json();
        setBookings(data);
    };

    useEffect(() => {
        fetchStats();
        fetchBookings();
    }, [filter]);

    const handleViewDetails = async (id) => {
        setLoadingDetail(true);
        try {
            const res = await fetch(`${APIENDPOINT}driverbooking.php?action=getBookingDetails&id=${id}&driver_id=${user.id}`);
            const data = await res.json();
            setSelectedDetail(data);

            setEditablePrice(data.booking.price);
            setPointsBalance(data.booking.user_balance || 0);
            setPointsToUse(data.booking.user_balance || 0);
        } catch (e) { toast.error("Failed to load details"); }
        setLoadingDetail(false);
    };

    const handleClaim = async (id) => {
        console.log(user, "iser")
        const res = await fetch(`${APIENDPOINT}driverbooking.php?action=claim&driver_id=${user.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ booking_id: id, driver_id: user.id })
        });
        const data = await res.json();
        if (data.status) {
            toast.success("Claimed!");
            setSelectedDetail(null);
            setFilter('accepted');
            fetchStats();
        } else { toast.error(data.error); }
    };

    const handleReject = async (id) => {
        if (!window.confirm("Are you sure you want to reject this booking?")) return;
        const res = await fetch(`${APIENDPOINT}driverbooking.php?action=reject&driver_id=${user.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ booking_id: id, driver_id: user.id })
        });
        const data = await res.json();
        if (data.status) {
            toast.error("Booking Rejected");
            setSelectedDetail(null);
            fetchStats();
            fetchBookings();
        }
    };
    const cards = [
        { id: 'available', label: 'Received', value: stats.available, icon: Inbox, color: 'text-purple-600', bg: 'bg-purple-50' },
        { id: 'today', label: "Today", value: stats.today, icon: Clock, color: 'text-orange-600', bg: 'bg-orange-50' },
        { id: 'upcoming', label: 'Upcoming', value: stats.upcoming, icon: Calendar, color: 'text-indigo-600', bg: 'bg-indigo-50' },
        { id: 'accepted', label: 'Accepted', value: stats.accepted, icon: CheckCircle2, color: 'text-emerald-600', bg: 'bg-emerald-50' },
        { id: 'completed', label: 'Completed', value: stats.completed, icon: Check, color: 'text-gray-600', bg: 'bg-gray-100' },
        { id: 'rejected', label: 'Rejected', value: stats.rejected, icon: XCircle, color: 'text-rose-600', bg: 'bg-rose-50' },
    ];
    const updateTripStatus = async (action, bookingId) => {
        try {
            const res = await fetch(`${APIENDPOINT}driverbooking.php?action=${action}&booking_id=${bookingId}&driver_id=${user.id}`);
            const data = await res.json();
            if (data.status) {
                toast.success("Status Updated");
                handleViewDetails(bookingId);
            }
        } catch (e) { toast.error("Update failed"); }
    };
    const handleStartJourney = async () => {
        if (isProcessing) return;
        setIsProcessing(true);
        const totalDuration = (selectedHours * 60) + selectedMinutes;

        const res = await fetch(`${APIENDPOINT}driverbooking.php?action=startJourney&driver_id=${user.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                booking_id: selectedDetail.booking.id,
                driver_id: user.id,
                user_id: selectedDetail.booking.user_id,
                duration: totalDuration,
                customer_name: selectedDetail.booking.name,
                customer_phone: selectedDetail.booking.phone_number,
                driver_name: user.name
            })
        });
        const data = await res.json();
        if (data.status) {
            toast.success("Journey Started! OTP sent to user.");
            setShowConfirmStart(false);
            setShowStartModal(false);
            handleViewDetails(selectedDetail.booking.id);
        }
        setIsProcessing(false);
    };
    const handleVerifyOTP = async () => {
        if (isProcessing) return;
        setIsProcessing(true);
        const res = await fetch(`${APIENDPOINT}driverbooking.php?action=verifyOTP&driver_id=${user.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ booking_id: selectedDetail.booking.id, otp: otpInput })
        });
        const data = await res.json();
        if (data.status) {
            toast.success("OTP Verified! Trip Started.");
            setShowOtpModal(false);
            handleViewDetails(selectedDetail.booking.id);
        } else { toast.error("Invalid OTP"); }
        setIsProcessing(false);
    };

    const handleCloseTripSubmit = async () => {
        if (isProcessing) return;

        // Validation: Ensure driver isn't using more points than the user has
        if (useLoyalty && pointsToUse > pointsBalance) {
            toast.error("Points exceed user balance");
            return;
        }

        setIsProcessing(true);
        // Calculation: 1000 points = 10 Pound (100 points = 1 Pound)
        const discount = useLoyalty ? (pointsToUse / 100) : 0;
        const finalPrice = (editablePrice - discount).toFixed(2);

        const res = await fetch(`${APIENDPOINT}driverbooking.php?action=closeTrip&driver_id=${user.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                booking_id: selectedDetail.booking.id,
                final_price: finalPrice,
                points_used: useLoyalty ? pointsToUse : 0
            })
        });
        const data = await res.json();
        if (data.status) {
            toast.success("Closing OTP sent to customer");
            setShowCloseTripModal(false);
            handleViewDetails(selectedDetail.booking.id);
        } else {
            toast.error(data.error || "Failed to send OTP");
        }
        setIsProcessing(false);
    };

    const handleVerifyClosingOTP = async () => {
        if (isProcessing) return;
        setIsProcessing(true);
        const res = await fetch(`${APIENDPOINT}driverbooking.php?action=verifyClosingOTP&driver_id=${user.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ booking_id: selectedDetail.booking.id, cotp: closingOtpInput })
        });
        const data = await res.json();
        if (data.status) {
            toast.success("Trip Completed Successfully!");
            setShowClosingOtpModal(false);
            setSelectedDetail(null);
            fetchStats();
            fetchBookings();
        } else { toast.error("Invalid Closing OTP"); }
        setIsProcessing(false);
    };

    const renderActionButtons = () => {
        const b = selectedDetail?.booking;
        if (!b) return null;

        // We use the 'accepted' filter view
        if (filter === 'accepted') {
            // trip_status_val is now mapped to the 1-4 flow from PHP
            const tripStep = parseInt(b?.trip_status_val || 0);

            switch (tripStep) {
                case 0: // Not started
                    return <button onClick={() => setShowStartModal(true)} className="flex-1 bg-indigo-600 text-white py-3 rounded-xl font-bold">Start Journey</button>;

                case 1: // Ready to pickup (OTP sent)
                    return <button onClick={() => setShowOtpModal(true)} className="flex-1 bg-orange-500 text-white py-3 rounded-xl font-bold">Enter Pickup OTP</button>;

                case 2: // Trip Started (In Transit)
                    return <button onClick={() => setShowCloseTripModal(true)} className="flex-1 bg-rose-600 text-white py-3 rounded-xl font-bold">Close Trip</button>;

                case 3: // Close Trip clicked (COTP sent)
                    return <button onClick={() => setShowClosingOtpModal(true)} className="flex-1 bg-emerald-600 text-white py-3 rounded-xl font-bold">Enter Closing OTP</button>;

                case 4: // Completed
                    return <div className="flex-1 text-center py-3 bg-emerald-50 text-emerald-600 font-bold rounded-xl border border-emerald-200">TRIP COMPLETED ✅</div>;

                default:
                    return null;
            }
        }

        if (filter === 'available') {
            return <button onClick={() => handleClaim(b.id)} disabled={isProcessing} className="flex-1 bg-emerald-600 text-white py-3 rounded-xl font-bold disabled:opacity-50">Approve &Accept Booking</button>;
        }

        return null;
    };

    return (
        <div className="space-y-6 pb-24">
            <h2 className="text-xl font-bold px-2">Driver Dashboard</h2>

            {/* Cards Grid */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-3 px-2">
                {cards.map((card) => (
                    <button key={card.id} onClick={() => setFilter(card.id)} className={cn("p-3 rounded-xl border transition-all text-left flex flex-col gap-1", filter === card.id ? "bg-white border-emerald-500 ring-2 ring-emerald-500/10 shadow-sm" : "bg-white border-gray-100 shadow-sm")}>
                        <div className={cn("p-1.5 w-fit rounded-lg", card.bg)}><card.icon className={cn("w-4 h-4", card.color)} /></div>
                        <p className="text-[10px] uppercase font-bold text-gray-400">{card.label}</p>
                        <p className="text-lg font-bold text-gray-900">{card.value}</p>
                    </button>
                ))}
            </div>

            {/* Bookings Table */}
            {/* Bookings List - Card Layout */}
            <div className="space-y-3 px-2">
                <div className="flex justify-between items-center mb-2 px-1">
                    <h3 className="font-bold text-gray-700 capitalize">{filter} Bookings</h3>
                    <span className="text-[10px] font-bold text-gray-400 uppercase bg-gray-100 px-2 py-0.5 rounded-full">
                        {bookings.length} Items
                    </span>
                </div>

                {bookings.length > 0 ? bookings.map((b) => (
                    <div
                        key={b.id}
                        className="p-4 flex flex-col md:flex-row md:items-center justify-between gap-4 hover:bg-white transition-colors bg-[#f1f1f1] border border-[#dddddd] rounded-[10px]"
                    >
                        {/* 1. Customer Info */}
                        <div className="flex flex-col min-w-[140px]">
                            <span className="text-[10px] font-mono text-gray-400">#{b.id}</span>
                            <span className="font-bold text-gray-900 truncate">{b.name}</span>
                            <div className="mt-1 flex flex-col gap-1">
                                <span className="text-[11px] text-gray-500 font-medium flex items-center gap-1">
                                    <Phone size={10} className="text-gray-400" /> {b.phone_number}
                                </span>
                                {/* Status mapping for Driver view */}
                                <span className={cn(
                                    "px-2 py-0.5 rounded-full text-[9px] font-bold uppercase w-fit",
                                    filter === 'accepted' ? "bg-emerald-50 text-emerald-700" :
                                        filter === 'rejected' ? "bg-rose-50 text-rose-700" : "bg-indigo-50 text-indigo-700"
                                )}>
                                    {filter}
                                </span>
                            </div>
                        </div>

                        {/* 2. Route with Visual Connectors */}
                        <div className="flex-1 min-w-0">
                            <div className="flex items-start gap-2 group">
                                <div className="flex flex-col items-center mt-1">
                                    <div className="w-2 h-2 rounded-full bg-emerald-500" />
                                    <div className="w-0.5 h-4 bg-gray-200" />
                                    <div className="w-2 h-2 rounded-full bg-rose-500" />
                                </div>
                                <div className="flex flex-col text-xs space-y-1 w-full overflow-hidden">
                                    <p className="text-gray-600 truncate font-medium">
                                        <span className="text-gray-400 mr-1">From:</span> {b.pickup_address_name}
                                    </p>
                                    <p className="text-gray-600 truncate font-medium">
                                        <span className="text-gray-400 mr-1">To:</span> {b.drop_address_name}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* 3. Date & Fare */}
                        <div className="grid grid-cols-2 md:flex md:flex-row gap-4 md:gap-8 items-center">
                            <div className="flex flex-col">
                                <span className="text-[10px] uppercase text-gray-400 font-bold tracking-tighter">Date & Time</span>
                                <div className="flex items-center gap-1 text-xs font-semibold text-gray-700">
                                    <Calendar size={12} className="text-gray-400" />
                                    {b.journey_date} <span className="text-emerald-600 ml-1">{b.journey_time}</span>
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-[10px] uppercase text-gray-400 font-bold tracking-tighter">Fare</span>
                                <div className="flex items-center gap-0.5 text-sm font-black text-emerald-600">
                                    £{b.price}
                                </div>
                            </div>
                        </div>

                        {/* 4. Action Button */}
                        <div className="flex gap-2 self-end md:self-center">
                            <button
                                onClick={() => handleViewDetails(b.id)}
                                className="p-3 bg-emerald-600 text-white rounded-xl hover:bg-emerald-700 transition-all shadow-md shadow-emerald-100 flex items-center gap-2 text-xs font-bold"
                            >
                                <Eye className="w-4 h-4" />
                                <span className="md:hidden">View Trip</span>
                            </button>
                        </div>
                    </div>
                )) : (
                    <div className="p-12 text-center bg-[#f1f1f1] border border-dashed border-gray-300 rounded-[10px]">
                        <Inbox className="w-8 h-8 text-gray-300 mx-auto mb-2" />
                        <p className="text-gray-400 text-sm">No bookings found in {filter}</p>
                    </div>
                )}
            </div>
            {showStartModal && (
                <div className="fixed inset-0 bg-black/60 z-[110] flex items-center justify-center p-4 backdrop-blur-sm">
                    <div className="bg-white p-6 rounded-2xl w-full max-w-sm">
                        <h3 className="text-lg font-bold mb-1">Arrival Duration</h3>
                        <p className="text-sm text-gray-500 mb-6">Estimated time to reach pickup?</p>
                        <div className="flex gap-4 mb-8">
                            <div className="flex-1">
                                <label className="text-[10px] font-bold text-gray-400 uppercase">Hours</label>
                                <select value={selectedHours} onChange={(e) => setSelectedHours(parseInt(e.target.value))} className="w-full p-3 bg-gray-50 border rounded-xl font-bold">
                                    {[0, 1, 2, 3, 4, 5].map(h => <option key={h} value={h}>{h} hr</option>)}
                                </select>
                            </div>
                            <div className="flex-1">
                                <label className="text-[10px] font-bold text-gray-400 uppercase">Minutes</label>
                                <select value={selectedMinutes} onChange={(e) => setSelectedMinutes(parseInt(e.target.value))} className="w-full p-3 bg-gray-50 border rounded-xl font-bold">
                                    {[0, 5, 10, 15, 20, 25, 30, 45].map(m => <option key={m} value={m}>{m} min</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <button onClick={() => setShowStartModal(false)} className="flex-1 py-3 text-gray-500 font-bold">Cancel</button>
                            <button onClick={() => setShowConfirmStart(true)} className="flex-[2] py-3 bg-emerald-600 text-white rounded-xl font-bold">Start</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL: Start Journey Confirmation */}
            {showConfirmStart && (
                <div className="fixed inset-0 bg-black/80 z-[120] flex items-center justify-center p-4">
                    <div className="bg-white p-6 rounded-2xl w-full max-w-xs text-center">
                        <ShieldCheck className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
                        <h3 className="text-lg font-bold mb-2">Confirm Start?</h3>
                        <p className="text-sm text-gray-500 mb-6">Are you sure you want to start the journey and notify the customer?</p>
                        <div className="flex gap-3">
                            <button onClick={() => setShowConfirmStart(false)} className="flex-1 py-2 text-gray-500 font-bold">Cancel</button>
                            <button onClick={handleStartJourney} disabled={isProcessing} className="flex-1 py-2 bg-emerald-600 text-white rounded-lg font-bold">Confirm</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL: Pickup OTP */}

            {showOtpModal && (
                <div className="fixed inset-0 bg-black/60 z-[110] flex items-center justify-center p-4 backdrop-blur-sm">
                    <div className="bg-white p-6 rounded-2xl w-full max-w-sm relative shadow-2xl">
                        {/* Top Right Close Button */}
                        <button
                            onClick={() => setShowOtpModal(false)}
                            className="absolute right-4 top-4 p-1.5 hover:bg-gray-100 rounded-full transition-colors text-gray-400"
                        >
                            <X size={20} />
                        </button>

                        <h3 className="text-lg font-bold mb-1 text-center">Enter Pickup OTP</h3>
                        <p className="text-xs text-gray-500 text-center mb-6">Ask the customer for the 4-digit code</p>

                        <input
                            type="text"
                            maxLength={4}
                            placeholder="0000"
                            className="w-full text-center text-3xl font-black p-4 border-2 border-emerald-100 bg-emerald-50/30 rounded-xl mb-6 focus:border-emerald-500 outline-none transition-all tracking-widest"
                            value={otpInput}
                            onChange={(e) => setOtpInput(e.target.value)}
                        />

                        <div className="flex gap-3">
                            <button
                                onClick={() => setShowOtpModal(false)}
                                className="flex-1 py-3 text-gray-500 font-bold hover:bg-gray-50 rounded-xl transition-colors"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleVerifyOTP}
                                disabled={isProcessing}
                                className="flex-[2] py-3 bg-emerald-600 text-white rounded-xl font-bold hover:bg-emerald-700 shadow-lg shadow-emerald-100 disabled:opacity-50 disabled:shadow-none transition-all"
                            >
                                Verify & Start Trip
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* MODAL: Close Trip (Loyalty Points) */}
            {showCloseTripModal && (
                <div className="fixed inset-0 bg-black/60 z-[110] flex items-center justify-center p-4">
                    <div className="bg-white p-6 rounded-2xl w-full max-w-md shadow-2xl">
                        <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                            <Euro className="w-5 h-5 text-rose-600" /> Close Trip
                        </h3>

                        <div className="space-y-4 mb-6">
                            {/* Editable Price Field */}
                            <div>
                                <label className="text-[10px] font-bold text-gray-400 uppercase ml-1">Negotiated Trip Price (£)</label>
                                <input
                                    type="number"
                                    value={editablePrice}
                                    onChange={(e) => setEditablePrice(parseFloat(e.target.value) || 0)}
                                    className="w-full p-4 bg-gray-50 border-2 border-gray-100 rounded-xl font-bold text-2xl focus:border-rose-500 outline-none transition-all"
                                />
                            </div>

                            {/* Loyalty Points Section */}
                            <div className={cn(
                                "p-4 rounded-xl border-2 transition-all",
                                useLoyalty ? "bg-amber-50 border-amber-200" : "bg-gray-50 border-gray-100"
                            )}>
                                <div className="flex justify-between items-center mb-3">
                                    <div className="flex items-center gap-2 font-bold text-amber-700">
                                        <Gift className="w-5 h-5" />
                                        User Loyalty Points
                                    </div>
                                    <input
                                        type="checkbox"
                                        checked={useLoyalty}
                                        onChange={(e) => setUseLoyalty(e.target.checked)}
                                        className="w-6 h-6 accent-amber-600 cursor-pointer"
                                    />
                                </div>

                                <p className="text-xs text-amber-700/70 mb-3 font-medium">
                                    Customer balance: <span className="font-bold">{pointsBalance} points</span> (£{(pointsBalance / 100).toFixed(2)})
                                </p>

                                {useLoyalty && (
                                    <div className="animate-in slide-in-from-top-2 duration-200">
                                        <input
                                            type="number"
                                            max={pointsBalance}
                                            value={pointsToUse}
                                            onChange={(e) => setPointsToUse(Math.min(pointsBalance, parseInt(e.target.value) || 0))}
                                            className="w-full p-3 bg-white border border-amber-200 rounded-lg text-lg font-bold text-amber-700 outline-none"
                                            placeholder="Enter points to deduct"
                                        />
                                        <p className="text-[10px] text-amber-600 mt-1 ml-1 uppercase font-bold">
                                            - £{(pointsToUse / 100).toFixed(2)} Discount
                                        </p>
                                    </div>
                                )}
                            </div>

                            {/* Final Calculated Display */}
                            <div className="flex justify-between items-center p-4 bg-gray-900 rounded-xl text-white">
                                <span className="font-bold text-gray-400">Total to Collect:</span>
                                <span className="text-3xl font-black text-emerald-400">
                                    £{(editablePrice - (useLoyalty ? pointsToUse / 100 : 0)).toFixed(2)}
                                </span>
                            </div>
                        </div>

                        <div className="flex gap-3">
                            <button
                                onClick={() => setShowCloseTripModal(false)}
                                className="flex-1 py-4 text-gray-500 font-bold hover:bg-gray-50 rounded-xl transition-colors"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleCloseTripSubmit}
                                disabled={isProcessing}
                                className="flex-[2] py-4 bg-rose-600 hover:bg-rose-700 text-white rounded-xl font-bold shadow-lg shadow-rose-200 disabled:opacity-50 flex items-center justify-center gap-2"
                            >
                                Send Closing OTP
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL: Closing OTP */}
            {showClosingOtpModal && (
                <div className="fixed inset-0 bg-black/60 z-[110] flex items-center justify-center p-4">
                    <div className="bg-white p-6 rounded-2xl w-full max-w-sm text-center">
                        <h3 className="text-lg font-bold mb-4">Enter Closing OTP</h3>
                        <p className="text-sm text-gray-500 mb-4">Ask customer for the OTP sent to their mobile</p>
                        <input type="text" maxLength={4} className="w-full text-center text-3xl font-bold p-4 border rounded-xl mb-4" value={closingOtpInput} onChange={(e) => setClosingOtpInput(e.target.value)} />
                        <div className="flex gap-3">
                            <button onClick={handleVerifyClosingOTP} disabled={isProcessing} className="w-50 py-3 bg-emerald-600 text-white rounded-xl font-bold">Complete Trip</button>
                            <button onClick={() => setShowClosingOtpModal(false)} className="flex-1 py-4 font-bold text-gray-400" style={{ border: '1px solid', borderRadius: '10px' }}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
            {/* DETAILED MODAL */}
            {selectedDetail && selectedDetail.booking && (
                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col shadow-2xl animate-in fade-in zoom-in duration-200">

                        {/* Header */}
                        <div className="p-5 border-b flex justify-between items-center bg-gray-50">
                            <div>
                                <h3 className="text-lg font-bold text-gray-900">Journey Details</h3>
                                {/* Use ?. for safety */}
                                <p className="text-xs text-gray-500">Booking ID: #{selectedDetail?.booking?.id}</p>
                            </div>
                            <button onClick={() => setSelectedDetail(null)} className="p-2 hover:bg-gray-200 rounded-full transition-colors"><X className="w-5 h-5" /></button>
                        </div>

                        {/* Content */}
                        <div className="p-6 overflow-y-auto space-y-6">
                            {/* Customer Section */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-emerald-50/50 p-4 rounded-xl border border-emerald-100">
                                <div className="flex items-center gap-3">
                                    <User className="w-5 h-5 text-emerald-600" />
                                    <div><p className="text-[10px] uppercase text-emerald-600 font-bold">Name</p><p className="text-sm font-bold">{selectedDetail?.booking?.name}</p></div>
                                </div>
                                <div className="flex items-center gap-3">
                                    <Phone className="w-5 h-5 text-emerald-600" />
                                    <div>
                                        <p className="text-[10px] uppercase text-emerald-600 font-bold">Phone</p>
                                        <a
                                            href={`tel:${selectedDetail?.booking?.phone_number}`}
                                            className="text-sm font-bold text-gray-900 hover:text-emerald-700 hover:underline transition-all block"
                                        >
                                            {selectedDetail?.booking?.phone_number}
                                        </a>
                                    </div>
                                </div>
                                <div className="flex items-center gap-3">
                                    <MessageSquare className="w-5 h-5 text-emerald-600" />
                                    <div><p className="text-[10px] uppercase text-emerald-600 font-bold">WhatsApp</p><p className="text-sm font-bold">{selectedDetail?.booking?.whatsapp_number}</p></div>
                                </div>
                            </div>

                            {/* Schedule Section */}
                            <div className="grid grid-cols-2 gap-4">
                                <div className="flex items-center gap-3 p-3 border rounded-xl">
                                    <Calendar className="w-5 h-5 text-gray-400" />
                                    <div><p className="text-[10px] uppercase text-gray-500">Date</p><p className="text-sm font-bold">{selectedDetail?.booking?.journey_date}</p></div>
                                </div>
                                <div className="flex items-center gap-3 p-3 border rounded-xl">
                                    <Clock className="w-5 h-5 text-gray-400" />
                                    <div><p className="text-[10px] uppercase text-gray-500">Time</p><p className="text-sm font-bold">{selectedDetail?.booking?.journey_time}</p></div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="flex items-center gap-3 p-3 border rounded-xl">
                                    <Route className="w-5 h-5 text-gray-400" />
                                    <div><p className="text-[10px] uppercase text-gray-500">Distance</p><p className="text-sm font-bold">{selectedDetail?.booking?.distance}</p></div>
                                </div>
                                <div className="flex items-center gap-3 p-3 border rounded-xl">
                                    <Euro className="w-5 h-5 text-gray-400" />
                                    <div><p className="text-[10px] uppercase text-gray-500">Price</p><p className="text-sm font-bold">€{selectedDetail?.booking?.price}</p></div>
                                </div>
                            </div>
                            {/* Route Timeline */}
                            <div className="space-y-4">
                                <h4 className="text-sm font-bold text-gray-700 flex items-center gap-2">
                                    <MapPinned className="w-4 h-4" /> Route Timeline
                                </h4>
                                <div className="relative pl-6 space-y-6 before:content-[''] before:absolute before:left-[11px] before:top-2 before:bottom-2 before:w-0.5 before:bg-gray-200">

                                    {/* CLICKABLE PICKUP */}
                                    <div className="relative group">
                                        <div className="absolute -left-[21px] top-1 w-4 h-4 rounded-full bg-emerald-500 border-4 border-white shadow-sm ring-1 ring-emerald-500 group-hover:scale-110 transition-transform"></div>
                                        <a
                                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selectedDetail?.booking?.pickup_address)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="block cursor-pointer"
                                        >
                                            <p className="text-[10px] uppercase font-bold text-emerald-600">Pickup</p>
                                            <p className="text-sm font-medium text-gray-900 group-hover:text-emerald-700 group-hover:underline decoration-emerald-200 transition-all">
                                                {selectedDetail?.booking?.pickup_address}
                                            </p>
                                        </a>
                                    </div>

                                    {/* CLICKABLE INTERMEDIATE POINTS */}
                                    {selectedDetail?.points?.map((pt, idx) => (
                                        <div key={idx} className="relative group">
                                            <div className="absolute -left-[21px] top-1 w-4 h-4 rounded-full bg-amber-400 border-4 border-white shadow-sm ring-1 ring-amber-400 group-hover:scale-110 transition-transform"></div>
                                            <a
                                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(pt.points_address)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="block cursor-pointer"
                                            >
                                                <p className="text-[10px] uppercase font-bold text-amber-600">Stop {idx + 1}</p>
                                                <p className="text-sm font-medium text-gray-900 group-hover:text-amber-700 group-hover:underline decoration-amber-200 transition-all">
                                                    {pt.points_address}
                                                </p>
                                            </a>
                                        </div>
                                    ))}

                                    {/* CLICKABLE DROP-OFF */}
                                    <div className="relative group">
                                        <div className="absolute -left-[21px] top-1 w-4 h-4 rounded-full bg-rose-500 border-4 border-white shadow-sm ring-1 ring-rose-500 group-hover:scale-110 transition-transform"></div>
                                        <a
                                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selectedDetail?.booking?.drop_address)}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="block cursor-pointer"
                                        >
                                            <p className="text-[10px] uppercase font-bold text-rose-600">Drop</p>
                                            <p className="text-sm font-medium text-gray-900 group-hover:text-rose-700 group-hover:underline decoration-rose-200 transition-all">
                                                {selectedDetail?.booking?.drop_address}
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="p-5 border-t bg-gray-50 flex gap-3">
                            <button onClick={() => setSelectedDetail(null)} className="px-6 py-3 border rounded-xl">Close</button>
                            {renderActionButtons()}
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};